import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';
import { deprecatedConnectorDocLink } from 'app/shared/constants/links.const';

export const azureMariaDBTableMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.azureMariaDB.datasetType,
    displayName: format(stringResources.ModelName_DisplayTextLegacyTemplate, stringResources.AzureMariaDB_DisplayText),
    supportLinkedServiceTypes: [adfModelTypeMap.azureMariaDB.linkedServiceType],
    warningMessage: stringResources.Connector_Legacy_IsDeprecatedWarning,
    warningMessageHyperlink: deprecatedConnectorDocLink,
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-AzureMariaDB'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['Azure']
};
